import "../insWaterfallDatapointChart/insWaterfallDatapointChart.scss";
import React from "react";
import { dataLabelFormatter } from "../insHorizontalBarChart/ins-horizontal-bar-chart-formatter";
import { useGetWaterfallDatapointConfig } from "../insWaterfallDatapointChart/helper";
import { InsWaterfallDatapointBaseChart } from "../insWaterfallDatapointChart/insWaterfallDatapointBaseChart";
import { useGetDatapointsWidgetData } from "hooks/widget-data/use-datapoints";
import { ChartSelectValueFormatKind } from "store/current-dashboard/types";
export const InsWaterfallComparisonChart = (props) => {
    const [[root], queryState] = useGetDatapointsWidgetData(props);
    let waterfalls = root?.data?.length > 1 ? root?.data ?? [] : [];
    waterfalls = waterfalls.filter((w) => w?.series);
    const series = waterfalls?.flatMap((w) => w.series) || [];
    const configs = useGetWaterfallDatapointConfig(props, queryState, series);
    configs.options.series = waterfalls?.map((x) => ({
        borderWidth: 0,
        centerInCategory: true,
        data: x.series.map((s) => ({ ...s, className: s.isTotal ? "highcharts-sum" : "" })),
        dataLabels: {
            crop: false,
            enabled: true,
            formatter() {
                return dataLabelFormatter(this, ChartSelectValueFormatKind[configs.valueFormat], configs.displayValueType);
            },
            inside: false,
            overflow: "allow",
            useHTML: true
        },
        groupPadding: 0.08,
        id: x.name,
        lineWidth: 0,
        name: x.name,
        pointPadding: 0,
        type: "waterfall"
    }));
    configs.options.tooltip = {
        enabled: false
    };
    return React.createElement(InsWaterfallDatapointBaseChart, { widgetFactoryProps: props, configs: configs });
};
